import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { API_LOGIN_CALLBACK } from '../../config';

/**
 * Sass
 */
import '../../assets/styles/animations.scss';

/**
 * Hooks
 */
import { useTranslation } from 'react-i18next';

/**
 * MUI Components
 */
import { Box, Avatar, Typography, TextField, Button, Alert } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

async function loginUser(credentials) {
    const response = await fetch(API_LOGIN_CALLBACK, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.message || 'Unauthorized');
    }
    return data;
}

export default function Login({ setToken, credentials }) {

    const { t } = useTranslation();
    const [username, setUserName] = useState(credentials?.username || '');
    const [password, setPassword] = useState(credentials?.password || '');
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmit = async e => {
        e.preventDefault();
        setError(false);
        try {
            const data = await loginUser({ username, password });
            console.log(data);
            // Only allow users with an employee asigned
            if (!Object.hasOwn(data, 'sid') || !data.sid) {
                setError(true);
                setErrorMessage(t('User has no employee asigned. User login denied!'));
                setToken(null);
            } else {
                setToken(data);
            }
        } catch (err) {
            setError(true);
            setErrorMessage(t('Invalid credentials'));
        }
    }

    const ErrorMessage = ({ error }) => {
        if (error) {
            return <Alert severity="error" onClose={() => setError(false)}>{errorMessage}</Alert>;
        }
    }

    return (
        <Box
            sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                {t('Sign In')}
            </Typography>
            <Box component="form"
                onSubmit={handleSubmit}
                className={error ? 'shake' : ''}
                noValidate sx={{ mt: 1 }}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="username"
                    label={t('username')}
                    name="username"
                    autoComplete="username"
                    value={username}
                    autoFocus
                    onChange={e => setUserName(e.target.value)}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label={t('password')}
                    type="password"
                    id="password"
                    value={password}
                    autoComplete="current-password"
                    onChange={e => setPassword(e.target.value)}
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    {t('Sign In')}
                </Button>
                <ErrorMessage error={error} />
            </Box>
        </Box>
    )
}

Login.propTypes = {
    setToken: PropTypes.func.isRequired
}